// Auth utility functions for managing user session

export const saveUserData = (userData) => {
  localStorage.setItem('userData', JSON.stringify(userData));
};

export const getUserData = () => {
  const userData = localStorage.getItem('userData');
  if (userData) {
    try {
      return JSON.parse(userData);
    } catch (e) {
      return null;
    }
  }
  return null;
};

export const getToken = () => {
  const userData = getUserData();
  return userData ? userData.token : null;
};

export const isAdmin = () => {
  const userData = getUserData();
  // Check for both lowercase and the exact "Admin" from API
  return userData && (userData.role === 'Admin' || userData.role === 'admin');
};

export const isAuthenticated = () => {
  const userData = getUserData();
  return userData && userData.token;
};

export const logout = () => {
  localStorage.removeItem('userData');
};

export const getUserRole = () => {
  const userData = getUserData();
  return userData ? userData.role : null;
};

export const isStudent = () => {
  const userData = getUserData();
  const role = userData ? (userData.role || userData.Role) : null;
  return role === 'Student' || role === 'student';
};

export const isCompany = () => {
  const userData = getUserData();
  const role = userData ? (userData.role || userData.Role) : null;
  return role === 'Company' || role === 'company';
};

export const isCoordinator = () => {
  const userData = getUserData();
  const role = userData ? (userData.role || userData.Role) : null;
  return role === 'Cordinator' || role === 'cordinator';
};

